import React, { useEffect, useState } from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col, Card } from "react-bootstrap";
import { TextField } from "../reusable/TextField";
import getFarmerDetails from "./getFarmerDetails";
import editFarmerDetails from "./editFarmerDetails";
import validationSchema from "./validationSchema";
import ModalAlert from "../reusable/ModalAlert";
import { styles } from "./styles";
import moment from "moment";
import stateDistrictData from "../../assets/static/IndiaStateDistrict";
import stateDistrictTalukaData from "../../assets/static/IndiaStateDistrictTaluka";
import Select from "react-select";
import getCrops from "../IssueDetails/getAllCrops";
import getProducts from "../IssueDetails/getProducts";

const FarmerDetails = (props) => {
  const [isEdit, setIsEdit] = useState(false);
  const [contact, setContact] = useState(props.mobileNumber);
  const [farmerDetails, setFarmerDetails] = useState(null);
  const [showGetDetails, setShowGetDetailsAlert] = useState(false);
  const [showEditAlert, setShowEditAlert] = useState(false);
  const [showDuplicateAlert, setShowDuplicateAlert] = useState(false);
  const [selectedState, setSelectedState] = useState({ label: "", value: "" });
  const [selectedDistrict, setSelectedDistrict] = useState({
    label: "",
    value: "",
  });
  const [allCrops, setAllCrops] = useState([]);
  const [allProducts, setAllProducts] = useState([]);

  const loadFarmerDetails = async () => {
    const farmerDetailsResponse = await getFarmerDetails(contact);
    if (farmerDetailsResponse.status == 200) {
      setFarmerDetails(farmerDetailsResponse.data);
      setSelectedState({
        label: farmerDetailsResponse.data.state,
        value: farmerDetailsResponse.data.state,
      });
      setSelectedDistrict({
        label: farmerDetailsResponse.data.district,
        value: farmerDetailsResponse.data.district,
      });
    } else {
      setShowGetDetailsAlert(true);
    }
  };

  const loadCrops = async () => {
    const allCropsResponse = await getCrops();
    if (allCropsResponse.status == 200) {
      const reqcrops = [];
      allCropsResponse.data.map((item) => {
        reqcrops.push(item.crop);
      });
      setAllCrops(reqcrops);
    } else {
      console.log(allCropsResponse);
    }
  };

  const loadProducts = async () => {
    try {
      const res = await getProducts();
      if (res.status === 200) {
        const resProduct = [];
        res.data.map((item) => {
          resProduct.push(item.crop);
        });
        setAllProducts(res.data);
      }
    } catch (err) {
      console.error("Error fetching products", err);
    }
  };

  useEffect(() => {
    loadCrops();
    loadFarmerDetails();
    loadProducts();
  }, []);

  const handleEditFarmer = async (values) => {
    const editFarmerResponse = await editFarmerDetails(values);
    if (editFarmerResponse.status == 200) {
      window.location.reload();
    } else {
      if (editFarmerResponse.message.includes("422")) {
        setShowDuplicateAlert(true);
      } else {
        setShowEditAlert(true);
      }
    }
  };

  const detailItem = (label, value) => (
    <Col md={6} className="mb-3">
      <div style={{ fontSize: "0.8rem", color: "#61766a" }}>{label}</div>
      <div style={{ fontWeight: 600, color: "#203e2d" }}>{value || "-"}</div>
    </Col>
  );

  return (
    <div>
      {farmerDetails ? (
        <Formik
          initialValues={farmerDetails}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            if (selectedState.value && selectedDistrict.value) {
              values.state = selectedState.value;
              values.district = selectedDistrict.value;
              handleEditFarmer(values);
            }
          }}
        >
          {(formikProps) => {
            const {
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
              setFieldValue,
              isValid,
            } = formikProps;
            return (
              <Card
                style={{
                  borderRadius: 14,
                  border: "1px solid #d8e4dc",
                  boxShadow: "0 10px 24px rgba(0,0,0,0.08)",
                }}
              >
                <Card.Header style={styles.displayCardHeader}>
                  <Row>
                    <Col sm={6} style={{ alignSelf: "center" }}>
                      <h5 style={{ marginBottom: 0 }}>Farmer Profile</h5>
                    </Col>
                    <Col className="text-right mr-3" style={{ display: "flex", justifyContent: "flex-end", gap: "0.5rem", alignItems: "center" }}>
                      {!isEdit ? (
                        <>
                          <button
                            className="btn btn-light"
                            type="button"
                            onClick={() => setIsEdit(true)}
                          >
                            ✏️ Edit
                          </button>
                          <a href={`tel:${contact}`} style={{ textDecoration: "none" }}>
                            <button className="btn btn-warning" type="button">
                              📞 Call
                            </button>
                          </a>
                        </>
                      ) : (
                        <div>
                          <button
                            className="btn btn-success mr-3"
                            type="submit"
                            onClick={() => handleSubmit()}
                          >
                            Save
                          </button>
                          <button
                            className="btn btn-danger"
                            type="button"
                            onClick={() => window.location.reload()}
                          >
                            Cancel
                          </button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Card.Header>
                <Card.Body>
                  <Card
                    style={{
                      borderRadius: 10,
                      border: "1px solid #e0ece4",
                      backgroundColor: "#f5faf7",
                      marginBottom: "1rem",
                    }}
                  >
                    <Card.Body style={{ padding: "0.85rem 1rem" }}>
                      <Row>
                        <Col md={6} className="mb-2 mb-md-0">
                          <div
                            style={{ fontSize: "0.85rem", color: "#5e7366" }}
                          >
                            Farmer Name
                          </div>
                          <div style={{ fontWeight: 700, color: "#254b35" }}>
                            {values.fullName || "-"}
                          </div>
                        </Col>
                        <Col md={6}>
                          <div
                            style={{ fontSize: "0.85rem", color: "#5e7366" }}
                          >
                            Last Updated
                          </div>
                          <div style={{ fontWeight: 700, color: "#254b35" }}>
                            {moment(
                              values.updatedAt || values.createdAt,
                            ).format("DD-MMM-YYYY, hh:mm A")}
                          </div>
                        </Col>
                      </Row>
                      <hr
                        style={{ margin: "0.65rem 0", borderColor: "#dce9e0" }}
                      />
                      <Row>
                        <Col md={4} sm={6}>
                          <div
                            style={{ fontSize: "0.82rem", color: "#5e7366" }}
                          >
                            Village
                          </div>
                          <div style={{ fontWeight: 600 }}>
                            {values.townVillage || "-"}
                          </div>
                        </Col>
                        <Col md={4} sm={6}>
                          <div
                            style={{ fontSize: "0.82rem", color: "#5e7366" }}
                          >
                            District
                          </div>
                          <div style={{ fontWeight: 600 }}>
                            {values.district || "-"}
                          </div>
                        </Col>
                        <Col md={4} sm={12}>
                          <div
                            style={{ fontSize: "0.82rem", color: "#5e7366" }}
                          >
                            State
                          </div>
                          <div style={{ fontWeight: 600 }}>
                            {values.state || "-"}
                          </div>
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                  {!isEdit ? (
                    <>
                      <Card
                        style={{
                          borderRadius: 10,
                          border: "1px solid #e0ece4",
                          marginBottom: "1rem",
                        }}
                      >
                        <Card.Header
                          style={{
                            backgroundColor: "#f1f7f3",
                            color: "#29553D",
                            fontWeight: 700,
                          }}
                        >
                          Farmer Details
                        </Card.Header>
                        <Card.Body>
                          <Row>
                            {detailItem("Full Name", values.fullName)}
                            {detailItem("Mobile Number", values.mobileNumber)}
                            {detailItem(
                              "WhatsApp Number",
                              values.whatsappNumber,
                            )}
                            {detailItem("State", values.state)}
                            {detailItem("District", values.district)}
                            {detailItem("Town/Village", values.townVillage)}
                            {detailItem(
                              "Current Crops",
                              values.currentCropsCultivated,
                            )}
                            {detailItem(
                              "Previous Crops",
                              values.previousCropsCultivated,
                            )}
                            {detailItem("Paid Member", values.paid)}
                            {detailItem("Land Acreage", values.landAcreage)}
                            {detailItem(
                              "Existing Customer",
                              values.existingCustomer,
                            )}
                            {values.existingCustomer == "Yes"
                              ? detailItem(
                                  "Using Manshya Products Since",
                                  values.usingProductsSince,
                                )
                              : null}
                            {detailItem("Heard About", values.heardAbout)}
                            {detailItem("Dealer Preference", values.dealerPreference)}
                            {detailItem(
                              "Soil Testing Status",
                              values.soilTestingStatus,
                            )}
                            {values.soilTestingStatus == "Done"
                              ? detailItem(
                                  "Last Soil Tested On",
                                  values.lastSoilTestOn,
                                )
                              : null}
                            {detailItem(
                              "Registration Date",
                              moment(values.createdAt).format("DD-MMM-YYYY"),
                            )}
                            {detailItem(
                              "Last Updated",
                              moment(
                                values.updatedAt || values.createdAt,
                              ).format("DD-MMM-YYYY, hh:mm A"),
                            )}
                            {detailItem(
                              "Last Updated By",
                              values.updatedBy || "—",
                            )}
                          </Row>
                        </Card.Body>
                      </Card>
                    </>
                  ) : (
                    <Form>
                      <TextField
                        label="Full Name"
                        name="fullName"
                        type="text"
                        disabled={!isEdit}
                      />
                      <Row>
                        <Col md={6}>
                          <TextField
                            label="Mobile Number"
                            name="mobileNumber"
                            type="text"
                            disabled={true}
                          />
                        </Col>
                        <Col md={6}>
                          <TextField
                            label="WhatsApp Number"
                            name="whatsappNumber"
                            type="text"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={4}>
                          <label style={{ display: "block" }}>State</label>
                          <Select
                            name="state"
                            placeholder="Select State"
                            value={selectedState}
                            onBlur={handleBlur}
                            onChange={(selectedOption) => {
                              setSelectedState(selectedOption);
                            }}
                            isDisabled={!isEdit}
                            options={stateDistrictData.states.map((obj) => {
                              return { value: obj.state, label: obj.state };
                            })}
                          />
                          {!selectedState.value ? (
                            <div>
                              <text style={styles.errorStyle}>
                                {"Required"}
                              </text>
                            </div>
                          ) : null}
                        </Col>
                        {selectedState.value && (
                          <Col md={4}>
                            <label style={{ display: "block" }}>District</label>
                            <Select
                              name="district"
                              placeholder="Select District"
                              value={selectedDistrict}
                              onBlur={handleBlur}
                              onChange={(selectedOption) => {
                                setSelectedDistrict(selectedOption);
                              }}
                              isDisabled={!isEdit}
                              options={
                                selectedState &&
                                selectedState.value &&
                                stateDistrictData.states
                                  .filter(
                                    (obj) => obj.state === selectedState.value,
                                  )[0]
                                  .districts.map((district) => {
                                    return { value: district, label: district };
                                  })
                              }
                            />
                            {!selectedDistrict.value ? (
                              <div>
                                <text style={styles.errorStyle}>
                                  {"Required"}
                                </text>
                              </div>
                            ) : null}
                          </Col>
                        )}
                        <Col md={4}>
                          <TextField
                            label="Town/Village"
                            name="townVillage"
                            type="text"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label style={{ display: "block" }}>
                            Currently Cultivated Crops
                          </label>
                          <Select
                            defaultValue={values.currentCropsCultivated.split(
                              ",",
                            )}
                            name="currentCropsCultivated"
                            placeholder="Select Currently Cultivated Crops"
                            onBlur={handleBlur}
                            onChange={(selectedOption) => {
                              values.currentCropsCultivated =
                                selectedOption.toString();
                            }}
                            options={allCrops}
                            getOptionLabel={(optlabel) => optlabel}
                            getOptionValue={(optval) => optval}
                            isMulti={true}
                            isDisabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <label style={{ display: "block" }}>
                            Previously Cultivated Crops
                          </label>
                          <Select
                            defaultValue={values.previousCropsCultivated.split(
                              ",",
                            )}
                            name="previousCropsCultivated"
                            placeholder="Select Previously Cultivated Crops"
                            onBlur={handleBlur}
                            onChange={(selectedOption) => {
                              values.previousCropsCultivated =
                                selectedOption.toString();
                            }}
                            options={allCrops}
                            getOptionLabel={(optlabel) => optlabel}
                            getOptionValue={(optval) => optval}
                            isMulti={true}
                            isDisabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col md={6}>
                          <label style={{ display: "block" }}>
                            Paid Member
                          </label>
                          <Field
                            style={{
                              width: "100%",
                              height: "40%",
                              marginBottom: "2rem",
                            }}
                            as="select"
                            label="Paid member"
                            name="paid"
                            disabled={!isEdit}
                          >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </Field>
                        </Col>
                        <Col md={6}>
                          <TextField
                            label="Land Acreage"
                            name="landAcreage"
                            type="text"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col md={6}>
                          <label style={{ display: "block" }}>
                            Existing Customer
                          </label>
                          <Field
                            style={{
                              width: "100%",
                              height: "40%",
                              marginBottom: "2rem",
                            }}
                            as="select"
                            label="Existing Customer"
                            name="existingCustomer"
                            disabled={!isEdit}
                          >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </Field>
                        </Col>
                        {values.existingCustomer == "Yes" ? (
                          <Col md={6}>
                            <TextField
                              label="Using Manshya Products Since (Year)"
                              name="usingProductsSince"
                              type="text"
                              disabled={!isEdit}
                            />
                          </Col>
                        ) : null}
                      </Row>
                      <Row className="mt-3">
                        <Col md={6}>
                          <label style={{ display: "block" }}>
                            Heard About
                          </label>
                          <Field
                            style={{
                              width: "100%",
                              height: "40%",
                              marginBottom: "2rem",
                            }}
                            as="select"
                            name="heardAbout"
                            disabled={!isEdit}
                          >
                            <option value="">Select option</option>
                            <option value="Farmer">Farmer</option>
                            <option value="Promotional material">Promotional material</option>
                            <option value="Staff">Staff</option>
                            <option value="Exhibition">Exhibition</option>
                            <option value="Dealer">Dealer</option>
                            <option value="Other">Other</option>
                          </Field>
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col md={6}>
                          <TextField
                            label="Dealer Preference"
                            name="dealerPreference"
                            type="text"
                            disabled={!isEdit}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col md={6}>
                          <label style={{ display: "block" }}>
                            Soil Testing Status
                          </label>
                          <Field
                            style={{
                              width: "100%",
                              height: "40%",
                              marginBottom: "2rem",
                            }}
                            as="select"
                            label="Soil Testing Status"
                            name="soilTestingStatus"
                            disabled={!isEdit}
                          >
                            <option value="Not Done">Not Done</option>
                            <option value="Done">Done</option>
                          </Field>
                        </Col>
                        {values.soilTestingStatus == "Done" ? (
                          <Col md={6}>
                            <TextField
                              label="Last Soil Tested On (Year)"
                              name="lastSoilTestOn"
                              type="text"
                              disabled={!isEdit}
                            />
                          </Col>
                        ) : null}
                      </Row>
                      <Row>
                        <Col md={6}>
                          <TextField
                            label="Farmer Registration Date"
                            name="createdAt"
                            type="text"
                            value={moment(values.createdAt).format(
                              "DD-MMM-YYYY, hh:mm A",
                            )}
                            disabled={true}
                          />
                        </Col>
                        <Col md={6}>
                          <TextField
                            label="Last Updated By"
                            name="updatedBy"
                            type="text"
                            value={values.updatedBy || "—"}
                            disabled={true}
                          />
                        </Col>
                      </Row>
                    </Form>
                  )}
                </Card.Body>
              </Card>
            );
          }}
        </Formik>
      ) : null}
      {showGetDetails && (
        <ModalAlert
          size="lg"
          variant="danger"
          message="Error Occurred while fetching farmer details!"
          resetCallback={setShowGetDetailsAlert}
        />
      )}
      {showEditAlert && (
        <ModalAlert
          size="lg"
          variant="danger"
          message="Error Occurred! Edit action failed."
          resetCallback={setShowEditAlert}
        />
      )}
      {showDuplicateAlert && (
        <ModalAlert
          size="lg"
          variant="danger"
          message="Farmer with id already exists in the system. Please try different farmer id."
          resetCallback={setShowDuplicateAlert}
        />
      )}
    </div>
  );
};

export default FarmerDetails;
